import React, { useState, useEffect } from 'react';
import style from '../group.module.scss';
import { Input } from '../../../../../components';
import { Utterance } from './Utterance';
import { Empty } from './Empty';
import { CRUD } from '../../../../../hooks';
import { EditUtterance } from '../';
import { SetState } from '../../../../../types';
import { validate } from '../../../../../utils/validation';

type Props = {
	isAdding: boolean;
	closeInput: () => void;
	editUtterance: EditUtterance;
	setEditUtterance: SetState<EditUtterance>;
	crud: CRUD;
	utterances: string[];
};

export function Utterances(props: Props) {
	const { isAdding, closeInput, editUtterance, setEditUtterance, utterances } =
		props;
	const { actions, deleteList, updateList } = props.crud;

	const visibleUtterances = utterances.filter((_el, i) => !deleteList.includes(i))
	const utteranceCount = visibleUtterances.length

	const [error, setError] = useState("")

	function validateUtterance(utterance: string) {
		setError("");
		const result = validate("utterance", utterance, [
			{
				message: "Utterance value can't be empty",
				fn: (value: string) => value.trim().length <= 0,
			},
			{
				message: "Utterance value already exists",
				fn: (value: string) =>
					visibleUtterances.findIndex((v) => v === value.trim()) !== -1,
			},
		]);
		if (result.utterance) {
			setError(result.utterance);
		}
		return result.utterance
	}

	function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
		const value = e.currentTarget.value
		if (e.keyCode === 13 && !error) {
		const error = validateUtterance(value)
			if(!error) {
				actions.addItem(value);
				e.currentTarget.value = '';
			}
		}
	}

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		const value = e.currentTarget.value
		validateUtterance(value)
	}

	useEffect(() => {
		setError("")
	}, [isAdding])

	return (
		<>
			{isAdding && (
				<div className={style.newUtterance}>
					<Input
					  onChange={handleChange}
						onKeyDown={handleKeyDown}
						autoFocus
						placeholder="Enter utterance"
						close={closeInput}
						error={error}
					/>
				</div>
			)}
			{utteranceCount > 0 ? (
				<div className={style.utterances}>
					{utterances.map((item, i) => {
						if (deleteList.includes(i)) {
							return null;
						}
						return (
							<Utterance
							  visibleUtterances={visibleUtterances}
								utteranceCount={utteranceCount}
								key={i}
								setUtterance={() => {
									actions.updateItem(
										editUtterance.index,
										editUtterance.currentValue,
									);
									setEditUtterance((prev) => ({ ...prev, index: -1 }));
								}}
								deleteUtterance={(index) => {
									actions.deleteItem(index);
								}}
								selectUtterance={(index, initialValue) => {
									closeInput(); // removes the "add utterance" input if present
									setEditUtterance((prev) => ({
										...prev,
										index,
										initialValue,
									}));
								}}
								utterance={updateList[i] ?? item}
								index={i}
								editUtterance={editUtterance}
								closeInput={() => {
									setEditUtterance((prev) => ({ ...prev, index: -1 }));
								}}
								onUtteranceEdit={(utterance) => {
									setEditUtterance((prev) => ({
										...prev,
										currentValue: utterance,
									}));
								}}
							/>
						);
					})}
				</div>
			) : (
				<Empty type="utterances" />
			)}
		</>
	);
}
